var $2407c222bf8df5ec$exports = {};
$2407c222bf8df5ec$exports = {
    "removeButtonLabel": `\u{5220}\u{9664}`,
    "removeDescription": `\u{6309}\u{4E0B}\u{201C}\u{5220}\u{9664}\u{201D}\u{4EE5}\u{5220}\u{9664}\u{6807}\u{8BB0}\u{3002}`
};


export {$2407c222bf8df5ec$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
